// extracted by mini-css-extract-plugin
export default {"caixona":"p5_caixona__udtcY","caixa":"p5_caixa__nRwge"};